import cacheGet from './list/cache.get'
import cacheUsage from './list/cache.usage'
import clientExample from './list/client.example'
import firestoreAdd from './list/firestore.add'
import firestoreCount from './list/firestore.count'
import firestoreDelete from './list/firestore.delete'
import firestoreGetLimit from './list/firestore.get-limit'
import firestoreGetOrderBy from './list/firestore.get-order-by'
import firestoreGetWhere from './list/firestore.get-where'
import firestoreGet from './list/firestore.get'
import fpqlGetArgument from './list/fpql.get-argument'
import fpqlGetField from './list/fpql.get-field'
import fpqlGetFields from './list/fpql.get-fields'
import fpqlGetMutation from './list/fpql.get-mutation'
import fpqlGetMutations from './list/fpql.get-mutations'
import fpqlGetTypeName from './list/fpql.get-type-name'
import fpqlGetType from './list/fpql.get-type'
import fpqlGetTypes from './list/fpql.get-types'
import httpExample from './list/http.example'
import inputsTypeToInput from './list/inputs.type-to-input'
import reactProviderComponent from './list/react.provider-component'
import reactUsage from './list/react.usage'
import renderPropsUseQuery from './list/render-props.use-query'
import stateExample from './list/state.example'
import typesUsage from './list/types.usage'

export const Examples = [
  cacheGet,
  cacheUsage,
  clientExample,
  firestoreAdd,
  firestoreCount,
  firestoreDelete,
  firestoreGetLimit,
  firestoreGetOrderBy,
  firestoreGetWhere,
  firestoreGet,
  fpqlGetArgument,
  fpqlGetField,
  fpqlGetFields,
  fpqlGetMutation,
  fpqlGetMutations,
  fpqlGetTypeName,
  fpqlGetType,
  fpqlGetTypes,
  httpExample,
  inputsTypeToInput,
  reactProviderComponent,
  reactUsage,
  renderPropsUseQuery,
  stateExample,
  typesUsage
]
